function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var e = Object.defineProperty, t = Object.setPrototypeOf, r = Object.create, n = Object.keys, l = "", s = Math.round, i = Math.max, o = function(e) {
    var _ref = _sliced_to_array(/([a-f\d]{3,6})/i.exec(e) || [], 2), t = _ref[1], r = t ? t.length : 0;
    if (3 === r) t = t[0] + t[0] + t[1] + t[1] + t[2] + t[2];
    else if (6 ^ r) return [
        0,
        0,
        0
    ];
    var n = parseInt(t, 16);
    return [
        n >> 16 & 255,
        n >> 8 & 255,
        255 & n
    ];
}, a = function(e, t, r) {
    return e === t && t === r ? e < 8 ? 16 : e > 248 ? 231 : s((e - 8) / 247 * 24) + 232 : 16 + 36 * s(e / 51) + 6 * s(t / 51) + s(r / 51);
}, c = function(e) {
    var t, r, n, l, o;
    return e < 8 ? 30 + e : e < 16 ? e - 8 + 90 : (e >= 232 ? t = r = n = (10 * (e - 232) + 8) / 255 : (o = (e -= 16) % 36, t = (e / 36 | 0) / 5, r = (o / 6 | 0) / 5, n = o % 6 / 5), l = 2 * i(t, r, n), l ? 30 + (s(n) << 2 | s(r) << 1 | s(t)) + (2 ^ l ? 0 : 60) : 30);
}, u = function() {
    var _o_NEXT_RUNTIME, _s_stdout, _t_window;
    var e = function(e) {
        return i.some(function(t) {
            return e.test(t);
        });
    }, t = globalThis, r = t.Deno, l = !!r, s = t.process || r || {}, i = s.argv || s.args || [], o = s.env || {}, a = -1;
    if (l) try {
        o = o.toObject();
    } catch (e) {
        a = 0;
    }
    var c = !!o.PM2_HOME && !!o.pm_id || ((_o_NEXT_RUNTIME = o.NEXT_RUNTIME) === null || _o_NEXT_RUNTIME === void 0 ? void 0 : _o_NEXT_RUNTIME.includes("edge")) || (l ? r.isatty(1) : !!((_s_stdout = s.stdout) === null || _s_stdout === void 0 ? void 0 : _s_stdout.isTTY)), u = "FORCE_COLOR", p = o[u], g = parseInt(p), d = isNaN(g) ? "false" === p ? 0 : -1 : g, f = u in o && d || e(/^-{1,2}color=?(true|always)?$/);
    return f && (a = d), a < 0 && (a = function(e, t, r) {
        var l = e.TERM, s = "," + n(e).join(",");
        return ({
            "24bit": 3,
            truecolor: 3,
            ansi256: 2,
            ansi: 1
        })[e.COLORTERM] || (e.TF_BUILD ? 1 : /,TEAMCI/.test(s) ? 2 : e.CI ? /,GIT(HUB|EA)/.test(s) ? 3 : 1 : !t || /-mono|dumb/i.test(l) ? 0 : r || /term-(kit|dir)/.test(l) ? 3 : /-256/.test(l) ? 2 : /scr|xterm|tty|ansi|color|[nm]ux|vt|cyg/.test(l) ? 1 : 3);
    }(o, c, "win32" === (l ? r.build.os : s.platform))), !d || o.NO_COLOR || e(/^-{1,2}(no-color|color=(false|never))$/) ? 0 : f && !a || ((_t_window = t.window) === null || _t_window === void 0 ? void 0 : _t_window.chrome) ? 3 : a;
}(), p = u > 0, g = {
    open: l,
    close: l
}, d = p ? function(e, t) {
    return {
        open: "\x1b[".concat(e, "m"),
        close: "\x1b[".concat(t, "m")
    };
} : function() {
    return g;
}, f = 39, b = 49, m = function(e, t) {
    return function(r, n, l) {
        return d(function(e, t, r) {
            return c(a(e, t, r));
        }(r, n, l) + e, t);
    };
}, _ = function(e) {
    return function(t, r, n) {
        return e(a(t, r, n));
    };
}, y = function(e) {
    return function(t) {
        return e.apply(void 0, _to_consumable_array(o(t)));
    };
}, h = function(e, t, r) {
    return d("38;2;".concat(e, ";").concat(t, ";").concat(r), f);
}, O = function(e, t, r) {
    return d("48;2;".concat(e, ";").concat(t, ";").concat(r), b);
}, $ = function(e) {
    return d("38;5;".concat(e), f);
}, x = function(e) {
    return d("48;5;".concat(e), b);
};
2 === u ? (h = _($), O = _(x)) : 1 === u && (h = m(0, f), O = m(10, b), $ = function(e) {
    return d(c(e), f);
}, x = function(e) {
    return d(c(e) + 10, b);
});
var T, w = {
    ansi256: $,
    bgAnsi256: x,
    fg: $,
    bg: x,
    rgb: h,
    bgRgb: O,
    hex: y(h),
    bgHex: y(O),
    visible: g,
    reset: d(0, 0),
    bold: d(1, 22),
    dim: d(2, 22),
    italic: d(3, 23),
    underline: d(4, 24),
    inverse: d(7, 27),
    hidden: d(8, 28)
}, R = "Bright", E = 30;
"black,red,green,yellow,blue,magenta,cyan,white".split(",").map(function(e) {
    T = "bg" + e[0].toUpperCase() + e.slice(1), w[e] = d(E, f), w[e + R] = d(60 + E, f), w[T] = d(E + 10, b), w[T + R] = d(70 + E++, b);
}), w.grey = w.gray = d(90, f), w.bgGrey = w.bgGray = d(100, b), w.strikethrough = w.strike = d(9, 29);
var v, C = {}, I = function(param, param1) {
    var e = param._p, r = param1.open, n = param1.close;
    var s = function(e) {
        for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            t[_key - 1] = arguments[_key];
        }
        var _String;
        if (!e) {
            if (r && r === n) return r;
            if (null == e || l === e) return l;
        }
        var i = e.raw ? (_String = String).raw.apply(_String, [
            e
        ].concat(_to_consumable_array(t))).replace(/\\n/g, "\n") : l + e, o = s._p, a = o._a, c = o._b;
        if (i.includes("")) for(; o;){
            var _$e = void 0, t1 = o.close, r1 = o.open, n1 = t1.length, s1 = l, a1 = 0;
            if (n1) {
                for(; ~(_$e = i.indexOf(t1, a1)); a1 = _$e + n1)s1 += i.slice(a1, _$e) + r1;
                i = s1 + i.slice(a1);
            }
            o = o._p;
        }
        return i.includes("\n") && (i = i.replace(/(\r?\n)/g, c + "$1" + a)), a + i + c;
    }, i = r, o = n;
    return e && (i = e._a + r, o = n + e._b), t(s, v), s._p = {
        open: r,
        close: n,
        _a: i,
        _b: o,
        _p: e
    }, s.open = i, s.close = o, s;
};
var M = function M() {
    var n = {
        isSupported: function() {
            return p;
        },
        strip: function(e) {
            return e.replace(/[][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g, l);
        },
        extend: function(l) {
            var _loop = function(t1) {
                var r = l[t1], n = (typeof r === "undefined" ? "undefined" : _type_of(r))[0], s = "s" === n ? h.apply(void 0, _to_consumable_array(o(r))) : r;
                C[t1] = "f" === n ? {
                    get: function() {
                        var _this = this;
                        return function() {
                            for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
                                e[_key] = arguments[_key];
                            }
                            return I(_this, r.apply(void 0, _to_consumable_array(e)));
                        };
                    }
                } : {
                    get: function() {
                        var r = I(this, s);
                        return e(this, t1, {
                            value: r
                        }), r;
                    }
                };
            };
            for(var t1 in l)_loop(t1);
            return v = r({}, C), t(n, v), n;
        }
    };
    return n.extend(w);
}, k = new M;
module.exports = k, module.exports.Ansis = M, k.default = k;
